import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData } from "./infoenum";

class PingResult extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      classes,
      result,
      subtest,
      subtestSignaltekResults,
      translate
    } = this.props;

    return subtestSignaltekResults && subtestSignaltekResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={1} />
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestSignaltekResults.teststarted
                  ? moment(subtestSignaltekResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_test_duration")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.testduration
                  ? subtestSignaltekResults.testduration
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_total_targets")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.totaltargets}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.passedText} color="inherit">
                {translate("result_passed_targets")}
              </Typography>
              <Typography className={classes.passedText} color="inherit">
                {subtestSignaltekResults.targetspassed}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography className={classes.failedText} color="inherit">
                {translate("result_failed_targets")}
              </Typography>
              <Typography className={classes.failedText} color="inherit">
                {subtestSignaltekResults.targetsfailed}
              </Typography>
            </Grid>
            <Grid item xs={1} />
          </Grid>
          <div className={classes.div_table}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableheader_first} rowSpan={2}>
                    {translate("sub_set_ping_targets")}
                  </TableCell>
                  <TableCell className={classes.tableheader} rowSpan={2}>
                    {translate("result_address")}
                  </TableCell>
                  <TableCell className={classes.tableheader} rowSpan={2}>
                    {translate("result_info")}
                  </TableCell>
                  <TableCell className={classes.tableheader} rowSpan={2}>
                    {translate("result_tx")}
                  </TableCell>
                  <TableCell className={classes.tableheader} rowSpan={2}>
                    {translate("result_rx")}
                  </TableCell>
                  <TableCell
                    className={classes.tableheaderlast_delay}
                    colSpan={3}
                    align="center"
                  >
                    {translate("result_delay")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    borderBottom="none"
                    className={classes.tableheaderlast}
                  >
                    {translate("result_min")}
                  </TableCell>
                  <TableCell className={classes.tableheaderlast}>
                    {translate("result_avg")}
                  </TableCell>
                  <TableCell className={classes.tableheaderlast}>
                    {translate("result_max")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subtestSignaltekResults &&
                subtestSignaltekResults.pingdata &&
                subtestSignaltekResults.pingdata.length
                  ? subtestSignaltekResults.pingdata.map((item, k) => {
                      return (
                        <TableRow key={k}>
                          <TableCell className={classes.tablecontent_first}>
                            {item.target}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.address}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            <div className={classes.infoHead}>
                              <div style={{ marginTop: 3 }}>
                                {infoData.find(o => o.name === item.info)
                                  ? translate(
                                      infoData.find(o => o.name === item.info)
                                        .id
                                    ) + " "
                                  : ""}
                              </div>
                              {item.status.toLowerCase() == "passed" ? (
                                <Icon className={classes.passState}>
                                  check_circle
                                </Icon>
                              ) : (
                                <Icon className={classes.failState}>
                                  cancel
                                </Icon>
                              )}
                            </div>
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.txcount}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.rxcount}
                          </TableCell>

                          <TableCell className={classes.tablecontentlast}>
                            {item.min}
                          </TableCell>
                          <TableCell className={classes.tablecontentlast}>
                            {item.avg}
                          </TableCell>
                          <TableCell className={classes.tablecontentlast}>
                            {item.max}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </div>
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getSubtestResults, subtest, pager } = this.props;

    getSubtestResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getSubtestResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getSubtestResults(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(PingResult);
